export const FolderType = {
	system: 'system',
	personal: 'personal',
};

export type FolderTypeItem = $Values<typeof FolderType>;
